import type { PaymentStatus } from '../lib/api/payments';

const MAP: Record<PaymentStatus, { label: string; bg: string; color: string; icon?: string }> = {
  DRAFT: { label: 'Nháp', bg: '#f1f5f9', color: '#475569' },
  PENDING_NVKT: { label: 'Chờ NV.KT lập PC', bg: '#fef3c7', color: '#a16207', icon: 'clock' },
  PENDING_KTT: { label: 'Chờ KTT duyệt', bg: '#fef3c7', color: '#a16207', icon: 'clock' },
  PENDING_CEO: { label: 'Chờ CEO ký', bg: '#dbeafe', color: '#1d4ed8', icon: 'user' },
  APPROVED: { label: 'Đã duyệt', bg: '#dcfce7', color: '#15803d', icon: 'check' },
  DISBURSED: { label: 'Đã chi', bg: '#ccfbf1', color: '#0f766e', icon: 'check-circle' },
  REJECTED: { label: 'Từ chối', bg: '#f1f5f9', color: '#64748b' },
  CANCELLED: { label: 'Đã huỷ', bg: '#f1f5f9', color: '#94a3b8' },
};

const ICON_PATHS: Record<string, string> = {
  clock: 'M12 6v6l4 2',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2',
  check: 'M20 6 9 17l-5-5',
  'check-circle': 'M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3',
  warn: 'm21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z',
};

export function StatusBadge({ status, urgent }: { status: PaymentStatus; urgent?: boolean }) {
  const meta = MAP[status];
  const isPending = status === 'PENDING_KTT' || status === 'PENDING_CEO';
  const showKhan = urgent && isPending;
  const bg = showKhan ? '#fee2e2' : meta.bg;
  const color = showKhan ? '#b91c1c' : meta.color;

  return (
    <span className="status-pill" style={{ background: bg, color }}>
      {showKhan ? (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d={ICON_PATHS.warn} />
          <line x1="12" x2="12" y1="9" y2="13" />
          <line x1="12" x2="12.01" y1="17" y2="17" />
        </svg>
      ) : meta.icon ? (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          {status === 'PENDING_KTT' && <circle cx="12" cy="12" r="10" />}
          {status === 'PENDING_CEO' && <circle cx="12" cy="7" r="4" />}
          <path d={ICON_PATHS[meta.icon]} />
        </svg>
      ) : null}
      {showKhan ? 'Khẩn' : meta.label}
    </span>
  );
}

export function TypePill({ type, advanceType: _advanceType }: { type: 'chi_thuong' | 'tam_ung' | 'ung_luong' | 'hoan_ung' | 'thuong_nong'; advanceType?: string | null }) {
  if (type === 'tam_ung') {
    return <span className="type-pill" style={{ color: '#2563EB', background: '#eff6ff' }}>Tạm ứng</span>;
  }
  if (type === 'ung_luong') return <span className="type-pill" style={{ color: '#15803d', background: '#f0fdf4' }}>Ứng lương</span>;
  if (type === 'hoan_ung') {
    return <span className="type-pill" style={{ color: '#7c3aed', background: '#f5f3ff' }}>Hoàn ứng</span>;
  }
  if (type === 'thuong_nong') {
    return <span className="type-pill" style={{ color: '#c2410c', background: '#fff7ed' }}>Thưởng nóng</span>;
  }
  return <span className="type-pill" style={{ color: '#334155', background: '#f8fafc' }}>Thanh toán</span>;
}
